import React, { FunctionComponent } from 'react'
import Svg, { Path } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

import { AuroraThemeType } from '../../utils/themes/ThemeProvider'

type Props = {
  size?: number | string
}

export const AuroraControlledMedsSecondaryRecIllustration: FunctionComponent<Props> = ({ size = 64 }) => {
  const { colors } = useTheme() as AuroraThemeType
  const { spotIllustration } = colors.icons

  return (
    <Svg width={size} height={size} viewBox='0 0 64 64' fill='none'>
      <Path
        d='M41.7885 53.0008H21.7727C20.4033 53.0008 19.2927 51.8637 19.2927 50.4616L18.3516 17.6133L45.6256 19.2976L44.2669 50.5152C44.2377 51.8952 43.1363 52.9992 41.7885 52.9992V53.0008Z'
        fill={spotIllustration.secondary.fill}
      />
      <Path
        d='M26.8077 40.3174C25.4194 39.1331 23.3564 39.3253 22.1998 40.7467C21.0431 42.1681 21.2309 44.2803 22.6191 45.4646L27.7411 49.8338C29.1293 51.018 31.1924 50.8258 32.349 49.4045C33.5057 47.9831 33.3179 45.8708 31.9297 44.6866L26.8077 40.3174Z'
        fill={spotIllustration.primary.fill}
      />
      <Path
        d='M32.3492 49.402C31.1923 50.823 29.1298 51.0154 27.7403 49.8309L25.2988 47.7649L29.4871 42.6172L31.9286 44.6832C33.3165 45.8676 33.5044 47.9794 32.3476 49.402H32.3492Z'
        fill={spotIllustration.primary.fill}
      />
      <Path
        d='M36.0794 39.7213L34.5378 46.3621C34.12 48.162 35.2064 49.9679 36.9643 50.3957C38.7223 50.8235 40.4862 49.7112 40.904 47.9113L42.4456 41.2705C42.8634 39.4706 41.7771 37.6647 40.0191 37.2369C38.2611 36.8091 36.4973 37.9214 36.0794 39.7213Z'
        fill={spotIllustration.primary.fill}
      />
      <Path
        d='M40.0225 37.2404C41.7801 37.6678 42.8676 39.4751 42.4486 41.2746L41.7277 44.432L35.3613 42.8817L36.0822 39.7243C36.4997 37.9248 38.2649 36.8114 40.0225 37.2404Z'
        fill={spotIllustration.primary.fill}
      />
      <Path
        d='M45.9857 15.1549L18.1387 14.9688C17.6858 14.9656 17.3099 15.3236 17.2791 15.7857L17.0019 20.0471C16.9695 20.5518 17.3608 20.9808 17.8552 20.9808H46.1443C46.6311 20.9808 47.0193 20.566 46.9993 20.0692L46.8344 15.9939C46.816 15.5271 46.4416 15.158 45.9857 15.1549Z'
        fill={spotIllustration.primary.fill}
      />
      <Path
        d='M44.0414 11.8701L20.492 11.0011C19.7526 10.9743 19.1041 11.4537 18.9732 12.1271L17.8965 17.6581H46.0793L45.4539 13.0671C45.363 12.4031 44.7654 11.8969 44.0414 11.8701Z'
        fill={spotIllustration.primary.fill}
      />
    </Svg>
  )
}
